import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { postLoadEditConfirmationMessage } from 'src/app/shared/constants';
import { ShippingLoadDetail } from 'src/app/shared/models';

@Component({
  selector: 'kbxl-shipping-load-cards',
  templateUrl: './shipping-load-cards.component.html',
  styleUrls: ['./shipping-load-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShippingLoadCardsComponent {
  @Input() loads: ShippingLoadDetail[];
  @Input() isBrokeredShipper = false;

  @Output() loadSelected = new EventEmitter<ShippingLoadDetail>();
  @Output() loadUnselected = new EventEmitter<ShippingLoadDetail>();
  @Output() removeLoad = new EventEmitter<ShippingLoadDetail>();
  @Output() deleteLoad = new EventEmitter<ShippingLoadDetail>();

  constructor(private route: ActivatedRoute, private router: Router, private confirmationService: ConfirmationService) {}

  onRowSelect(load: ShippingLoadDetail) {
    if (load.selected) {
      this.loadUnselected.emit(load);
    } else {
      this.loadSelected.emit(load);
    }
  }

  edit(load: any) {
    if (load && load.loadId && (load.manuallyCreated || load.isExternalLoad)) {
      if (load.onLoadshop) {
        this.confirmationService.confirm({
          message: postLoadEditConfirmationMessage,
          accept: () => {
            this.router.navigate(['edit', load.loadId], { relativeTo: this.route });
          },
        });
      } else {
        this.router.navigate(['edit', load.loadId], { relativeTo: this.route });
      }
    }
  }

  copy(load: any) {
    if (load && load.manuallyCreated && load.loadId) {
      this.router.navigate(['copy', load.loadId], { relativeTo: this.route });
    }
  }

  removeClicked(load: ShippingLoadDetail) {
    this.removeLoad.emit(load);
  }

  deleteClicked(load: ShippingLoadDetail) {
    this.deleteLoad.emit(load);
  }

  trackByFn(idx: number, item: ShippingLoadDetail) {
    return item.loadId;
  }
}
